module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_0.76b9cd05.png";